import PropTypes from 'prop-types'
import React from 'react'
import { Form } from 'semantic-ui-react'
import { InfoBubble } from '../../Admin/misc/InfoBubble'

class FormInput extends React.Component {
  render() {
    const { label, name, type, placeholder, defaultValue, onChange, required, tooltipText = null } = this.props
    const id = label.hashCode()
    return (
        <Form.Field>
          <label data-for={`tooltip-${'test'}`}>{label}{tooltipText && <InfoBubble id={name} content={tooltipText}/>}</label>
          <input
            className=""
            id={id}
            type={type}
            name={name}
            placeholder={placeholder}
            defaultValue={defaultValue}
            onInput={(e) => onChange(e.target)}
            required={required}
          />
        </Form.Field>
    )
   }
}

FormInput.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  tooltipText: PropTypes.string
}

FormInput.defaultProps = {
  type: 'text',
  placeholder: '',
  required: false,
}

export default FormInput
